import { Button } from '@bambi/component-library/src/components/Button/Button';
import { CloudArrowDownIcon } from '@heroicons/react/24/outline';

import { fleetInspectionSlice } from './fleetInspection.slice';
import { useAppDispatch } from 'src/app/store/hooks';

export function VehicleInspectionsRouteActions() {
  const dispatch = useAppDispatch();

  const handleDownload = () => {
    dispatch(fleetInspectionSlice.actions.setInspectionDownloadModal(true));
  };

  return (
    <Button onClick={handleDownload}>
      <CloudArrowDownIcon className="mr-2 h-5 w-5" /> Download
    </Button>
  );
}
